<template>
  <div
    :class="['section-title-wrap', {editable:isEditable},{'ui-hidden':hideGlobalUI}]"
    v-on-clickaway="deselect"  
    @click="menuSectionTitleClick"
    v-toggle-hover
    v-toggle-select
  >
    <transition name="fade">
      <drag-handle v-if="(hovering || selected) && editable"/>
    </transition>

    <editable-text
      tag="h4"
      :class="['section-title button-cluster-parent',{hovering:hovering}]"
      ref="title"
      :content="title"
      :editable="editable"
      @update="$emit('update', $event)"
    />
    
    <transition name="fade">
      <price-columns
        v-if="priceColumns.length || hovering || showUI"
        ref="priceColumnsComponent"
        class="section-price-columns"
        :prices="priceColumns"
        :isEditable="editable"
      ><i class="material-icons" slot="placeholder">view_column</i></price-columns>
    </transition>

  </div>

</template>

<script>
import ToggleHover from '../../toggle-hover'
import ToggleSelect from '../../toggle-select'
import VueClickaway from 'vue-clickaway'

import DividedPriceColumns from '../UI/DividedPriceColumns'
import DragHandle from '../UI/DragHandle'

import EditableTextField from '../EditableTextField'

import { mapState } from 'vuex'

export default {

  name: 'MenuSectionTitle',
  mixins : [ VueClickaway.mixin, ToggleHover, ToggleSelect ],
  props : [
    'title',
    'editable',
    'priceColumns'
  ],
  components : {
    'editable-text' : EditableTextField,
    'price-columns' : DividedPriceColumns,
    'drag-handle' : DragHandle,    
  },
  computed : {
    ...mapState(['hideGlobalUI'])
  },
  methods: {
    menuSectionTitleClick(event) {
      // Prevent event bubbling to section-title
      // if a child node was clicked
      if( !event.target.classList.contains('section-title') ) {
        event.stopPropagation();
        return false;
      }
      if( !this.selected ) {

        // If this item isn't currently selected,
        // focus on the item title to get the user started
        this.$nextTick()
          .then( () => {
            var p = this.$refs.title.$el;
            var s = window.getSelection();
            s.collapse(p.firstChild, p.innerText.length);
          })
      }      
    },
    addPriceColumn(item, event) {
      event.stopPropagation();
      this.$emit('addPriceColumn', item, event );
    }, // addPriceColumn

    focusNewPrice( priceIndex) {
      if( this.$refs.priceColumnsComponent ) {
        this.$refs.priceColumnsComponent.$refs[`price-${priceIndex}`][0].$el.focus()
      }
    }, // focusNewPrice
  },
  data () {return {}}
}
</script>

<style lang="scss">

$borderWidth : 2px;
$titleBottomMargin : .4rem;
@mixin bgPseudoElem {
  &:before {
    content : '';
    position:absolute;
    z-index:-1;
    height:calc(100% - #{$borderWidth*2} + #{$titleBottomMargin});
    width:calc(100% + 20px);
    right:-10px;
    top:1px;
    bottom:1px;
  }
}

@mixin hoverElem {
  @include bgPseudoElem;
  cursor:pointer;
  &:before {
    border-top:$borderWidth solid darken(white, 7%);
    border-bottom:$borderWidth solid darken(white, 7%);    
  }
  &:not(.selected):before{ 
    background-color:darken(white, 5%);
  }
}

@mixin selectedElem {
  @include hoverElem;
  // background:rgba(138, 251, 109, 0.2);  
  &:before {
    // $border:rgba(138, 251, 109, 0.6);
    $border:#40C2FF;
    $border:#37c120;
    border-top-color:$border;
    border-bottom-color:$border;
  }
}

.section-title-wrap {
  position:relative;
  display:flex;
  align-items:flex-end;
  border-bottom:2px solid black;
  margin-bottom:$titleBottomMargin;

  &.editable:not(.ui-hidden){
    &:hover {
      @include hoverElem;    
    }
    &.selected {
      @include selectedElem;
    }
    .section-title:not(.selected) {
      cursor:pointer;
    }

  }


  .has-subsections & {
    border-bottom:none;
    .section-title     {
      font-size:3.1rem;
      line-height:1;
    }
  }


  > .button-cluster {
    display:flex;
    position:absolute;
    right:0;
    bottom:0;
    transform:translate3D(100%,0,0);

  }

  .section-title {
    font-size:1.7rem;
    padding-top:0;
    margin-top:0;
    margin-bottom:0.3em;
    font-family: 'Jaldi', sans-serif;
    text-transform:lowercase;  
    font-weight:700;
    cursor:default;

    position:relative;
    flex: auto;
    border-bottom:none;
    margin-bottom:0;

    // Salient overrides
    @media only screen and (max-width: 1300px) {
      .section:not(.has-subsections) & {
        font-size:22px !important;
      }
    }
  }
} // .section-title-wrap

.section-price-columns {
  margin-bottom:.3em;  
}
.hover-controls {
}
</style>



// WEBPACK FOOTER //
// src/components/Menus/MenuSectionTitle.vue